import React, { Component } from "react";
import { connect } from "react-redux";

import { showDataUsageDetails } from "../actions/homepageActions";

import { humanFileSize, numberWithCommas } from "../utilities/utilities";

import { SemiCircleProgressMeter } from "./LinearProgressMeter";

import ButtonLink from "./ButtonLink";

// missing or zero limits/usage show as 0% instead of NaN% or Infinity%
const usagePercent = (used, limit) =>
	limit > 0 && used > 0 ? (used / limit) * 100 : 0;

class TenantUsageWidget extends Component {
	constructor(props, context) {
		super(props, context);
	}
	render() {
		return this.props.loading ? null : (
			<div style={{ marginTop: "auto" }}>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						borderBottom: "1px solid",
						borderColor: "var(--lw-dark-grey)",
						marginBottom: 16,
						paddingBottom: 8,
					}}
				>
					<div className="MainFontBold">Usage</div>
					<div>
						<ButtonLink
							onClick={() =>
								this.props.showDataUsageDetails({
									standardSizeHuman:
										this.props.standardSizeHuman,
									archivedSizeHuman:
										this.props.archivedSizeHuman,
									standardDataLimitHuman:
										this.props.standardDataLimitHuman,
									archivedDataLimitHuman:
										this.props.archivedDataLimitHuman,
									dataUsageCalculationTime:
										this.props.dataUsageCalculationTime,
									ocrLimit: this.props.ocrLimit,
									ocrUsage: this.props.ocrUsage,
									canRequestMonthlyOCRLimitIncrease:
										this.props
											.canRequestMonthlyOCRLimitIncrease,
									// increaseMonthlyOCR: this.props.increaseMonthlyOCR,
								})
							}
						>
							View Details
						</ButtonLink>
					</div>
				</div>
				<div
					style={{ display: "flex", justifyContent: "space-between" }}
				>
					<SemiCircleProgressMeter
						progress={this.props.standardDataUsagePercent}
						label={"Standard Data Usage"}
						key={"standardDataUsage"}
					/>
					<SemiCircleProgressMeter
						progress={this.props.archivedDataUsagePercent}
						label={"Archive Data Usage"}
						key={"archivedDataUsage"}
					/>
					{this.props.hideOCR !== true ? (
						<SemiCircleProgressMeter
							progress={this.props.ocrUsagePercent}
							label={"OCR Usage"}
							key={"ocrUsage"}
						/>
					) : null}
				</div>
			</div>
		);
	}
}
const editTenantMapStateToProps = (state) => {
	const {
		dataUsageCalculationTime,
		standardBytes,
		standardSizeHuman,
		archivedBytes,
		archivedSizeHuman,
	} = state.admin.tenantUsage;
	const standardDataLimitGB = state.admin.usageLimits.STORAGE_LIMIT_GB;
	const standardDataLimitBytes =
		(standardDataLimitGB || 0) * 1000 * 1000 * 1000;
	const standardDataLimitHuman = humanFileSize(standardDataLimitBytes, true);
	const standardDataUsagePercent = usagePercent(
		standardBytes,
		standardDataLimitBytes
	);

	const archivedDataLimitGB =
		state.admin.usageLimits.ARCHIVE_STORAGE_LIMIT_GB;
	const archivedDataLimitBytes =
		(archivedDataLimitGB || 0) * 1000 * 1000 * 1000;
	const archivedDataLimitHuman = humanFileSize(archivedDataLimitBytes, true);
	const archivedDataUsagePercent = usagePercent(
		archivedBytes,
		archivedDataLimitBytes
	);

	const ocrEnabled = state.admin.tenantFeatures.automaticOCR === 1;

	const ocrLimit = state.admin.usageLimits.OCR_PER_MONTH_NET;
	const ocrUsage = state.admin.tenantUsage.OCR_TRANSACTIONS_THIS_MONTH;
	const ocrUsagePercent = usagePercent(ocrUsage, ocrLimit);
	return {
		standardBytes: standardBytes || 0,
		standardSizeHuman: standardSizeHuman || "???",
		archivedBytes: archivedBytes || 0,
		archivedSizeHuman: archivedSizeHuman || "???",
		dataUsageCalculationTime,
		standardDataLimitHuman,
		standardDataUsagePercent,
		archivedDataLimitHuman,
		archivedDataUsagePercent,
		ocrLimit: numberWithCommas(ocrLimit || 0),
		ocrUsage: numberWithCommas(ocrUsage || 0),
		ocrUsagePercent,
		ocrEnabled,
		loading: state.admin.newEditTenantLoading,
		hideOCR: true,
	};
};

const homepageMapStateToProps = (state) => {
	const {
		dataUsageCalculationTime,
		standardBytes,
		standardSizeHuman,
		archivedBytes,
		archivedSizeHuman,
	} = state.homepage.dataUsageV2;
	const standardDataLimitGB = state.homepage.usageLimits.STORAGE_LIMIT_GB;
	const standardDataLimitBytes =
		(standardDataLimitGB || 0) * 1000 * 1000 * 1000;
	const standardDataLimitHuman = humanFileSize(standardDataLimitBytes, true);
	const standardDataUsagePercent = usagePercent(
		standardBytes,
		standardDataLimitBytes
	);

	const archivedDataLimitGB =
		state.homepage.usageLimits.ARCHIVE_STORAGE_LIMIT_GB;
	const archivedDataLimitBytes =
		(archivedDataLimitGB || 0) * 1000 * 1000 * 1000;
	const archivedDataLimitHuman = humanFileSize(archivedDataLimitBytes, true);
	const archivedDataUsagePercent = usagePercent(
		archivedBytes,
		archivedDataLimitBytes
	);

	const ocrEnabled = state.homepage.tenantFeatures.automaticOCR === 1;

	const ocrLimit = state.homepage.usageLimits.OCR_PER_MONTH_NET;
	const ocrUsage = state.homepage.tenantUsage.OCR_TRANSACTIONS_THIS_MONTH;
	const ocrUsagePercent = usagePercent(ocrUsage, ocrLimit);
	return {
		standardBytes: standardBytes || 0,
		standardSizeHuman: standardSizeHuman || "???",
		archivedBytes: archivedBytes || 0,
		archivedSizeHuman: archivedSizeHuman || "???",
		dataUsageCalculationTime,
		standardDataLimitHuman,
		standardDataUsagePercent,
		archivedDataLimitHuman,
		archivedDataUsagePercent,
		ocrLimit: numberWithCommas(ocrLimit || 0),
		ocrUsage: numberWithCommas(ocrUsage || 0),
		ocrUsagePercent,
		ocrEnabled,
		loading: state.homepage.loading,
		canRequestMonthlyOCRLimitIncrease:
			state.user.canRequestMonthlyOCRLimitIncrease,
	};
};

export const HomepageTenantUsageWidget = connect(homepageMapStateToProps, {
	showDataUsageDetails,
})(TenantUsageWidget);

export const EditTenantUsageWidget = connect(editTenantMapStateToProps, {
	showDataUsageDetails,
})(TenantUsageWidget);
